export default function getCurrentYear() {
    var elements = document.querySelectorAll('.dyn-year');
    var currentYear = new Date().getFullYear();
    elements.forEach(function(element) {
        element.innerHTML = currentYear;
    });
}
